<script setup>
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

defineProps({ content: { type: String, default: '' } });
const { formatMessage } = useMessageFormatter();
</script>

<template>
  <div
    v-dompurify-html="formatMessage(content)"
    class="message-content min-w-0 text-sm leading-5 [overflow-wrap:anywhere] [&_p]:m-0 [&_pre]:max-w-full [&_pre]:overflow-x-auto [&_a]:text-n-blue-text [&_a]:underline"
  />
</template>
